import React from 'react';
import PropTypes from 'prop-types';
import SMFormTextArea from 'components/dashboard/form/SMFormTextArea';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMReservationEditViewNote extends React.Component{
  textAreaDidEndEditing(e) {
    this.props.delegate.changeNote(e.currentTarget.name, e.currentTarget.value);
  }
  
  render(){
    return(
      <td>
        <SMFormTextArea
          name="note"
          value={this.props.note}
          errorText={SMFormatHelper.errorText('Reservation', 'note', this.props.errors)}
          placeholderText="メモを追加"
          delegate={this} />
      </td>
    );
  }
}

SMReservationEditViewNote.propTypes = {
  note: PropTypes.string,
  errors: PropTypes.array.isRequired,
  delegate: PropTypes.object
};

export default SMReservationEditViewNote;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationEditViewNote.jsx